import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AuthService } from "@services/auth.service";
import { useCallback, useEffect, useState } from "react";
import { AndroidDataEventMap } from "@declarations/event";
import { androidLoginBiometric } from "@utils/android";
import { NoticeType } from "antd/es/message/interface";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<{ username: string; password: string }>();
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const listener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-login-biometric"]>) => {
      form.setFieldsValue(ev.data);
      form.submit();
    },
    [form]
  );

  useEffect(() => {
    const requestBiometric = setTimeout(() => {
      androidLoginBiometric();
    }, 500);
    window.addEventListener("on-login-biometric", listener);

    return () => {
      clearTimeout(requestBiometric);
      window.removeEventListener("on-login-biometric", listener);
    };
  }, [listener]);
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<AuthLogin>({
  //   resolver: yupResolver<AuthLogin>(authLoginSchema),
  // });

  const { mutate, isPending } = useMutation({
    mutationFn: AuthService.login,
    onSuccess: (response) => {
      if (response.success) {
        navigate(response.data!.redirect);
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div className="tw-text-sm tw-text-other-500 tw-text-center tw-mt-2">
        Silakan masukkan data Anda
      </div>
      <Form
        className="tw-mt-16 tw-w-11/12 tw-mx-auto tw-px-6"
        name="basis"
        layout="vertical"
        onFinish={(data) => mutate(data)}
        // onFinish={handleSubmit((data) => mutate(data))}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: "NIS tidak boleh kosong!" }]}
        >
          <Input
            prefix={<UserOutlined />}
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="NIS/Nomor Induk Siswa"
            // {...register("username")}
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "Password tidak boleh kosong!" }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
            placeholder="Password"
          />
        </Form.Item>

        <Form.Item>
          <Button
            className="tw-h-9 tw-w-full tw-mt-1 bg-gradient tw-text-other-100 focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            htmlType="submit"
            loading={isPending}
          >
            Masuk
          </Button>
        </Form.Item>
      </Form>

      {/* <div className="tw-text-sm tw-text-center tw-mt-1">
        <Link
          to={
            "https://api.whatsapp.com/send?phone=+6282300146352&text=Assalamualaikum"
          }
          replace={false}
          target="_blank"
          className="tw-text-primary-hg"
        >
          <LockOutlined /> Lupa Password?
        </Link>
      </div> */}
    </>
  );
};
